import { useTranslation } from "react-i18next";
import { Tooltip, Avatar, Stack } from "@material-ui/core";
import { parseCustomerBudget } from "utils/contacts/helper";
import type { ContactColumnsId } from "utils/contacts/table";
import type {
  RealEstateContact,
  PhoneCallParsedOpenAiResponseCustomerDetails
} from "../../../../../@types/sharedSchema";
import type { ReactNode } from "react";

type ContactTableAiFieldFlagProps = {
  id: ContactColumnsId;
  contact?: Partial<RealEstateContact>;
  children: ReactNode;
};

export function ContactTableAiFieldFlag({
  id,
  contact,
  children
}: ContactTableAiFieldFlagProps): JSX.Element {
  const { t: translate } = useTranslation();

  if (!contact) return <>{children}</>;

  const validAiField = isValidAiField(id);

  if (!validAiField) return <>{children}</>;

  let parsedAiField = contact.AICustomerDetailsMetadata?.[id] as string | number;
  let parsedContactField = contact[id] as string | number;

  if (id === "customerBudget") {
    parsedAiField = parseCustomerBudget(parsedAiField);
    parsedContactField = parseCustomerBudget(parsedContactField);
  }

  const validFields = parsedAiField && parsedContactField;
  const fieldsAreEqual = parsedAiField === parsedContactField;

  const showAiFlag = validFields && fieldsAreEqual;

  if (!showAiFlag) return <>{children}</>;

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {children}
      <Tooltip
        title={translate("contactsPage.control.editedWithAi")}
        PopperProps={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -4]
              }
            }
          ]
        }}
      >
        <Avatar sx={{ width: 18, height: 18 }} src="/static/icons/ai.svg" />
      </Tooltip>
    </Stack>
  );
}

type AiField = keyof PhoneCallParsedOpenAiResponseCustomerDetails;

const aiFields: AiField[] = [
  "roomsMin",
  "roomsMax",
  "callerLastName",
  "customerBudget",
  "callerFirstName",
  "additionalNotes"
];

function isValidAiField(field: string): field is AiField {
  return aiFields.includes(field as AiField);
}
